var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { get, set } from '../utils';
import { AsyncStatus } from './constants';
// todo переделать все на get/set
export var asyncStart = function (state, _a) {
    var key = _a.key, idx = _a.idx;
    var asyncStore = state.async;
    var path = idx !== undefined ? [key, idx] : [key];
    var asyncState = get(asyncStore, path);
    return __assign(__assign({}, state), { async: set(asyncStore, path, __assign(__assign({}, asyncState), { status: AsyncStatus.PENDING })) });
};
export var asyncSuccess = function (state, _a) {
    var key = _a.key, idx = _a.idx, data = _a.data, meta = _a.meta;
    var asyncStore = state.async;
    var path = idx !== undefined ? [key, idx] : [key];
    var asyncState = get(asyncStore, path);
    return __assign(__assign({}, state), { async: set(asyncStore, path, __assign(__assign({}, asyncState), { status: AsyncStatus.SUCCESS, data: data, meta: meta })) });
};
export var asyncError = function (state, _a) {
    var key = _a.key, idx = _a.idx, error = _a.error;
    var asyncStore = state.async;
    var path = idx !== undefined ? [key, idx] : [key];
    var asyncState = get(asyncStore, path);
    return __assign(__assign({}, state), { async: set(asyncStore, path, __assign(__assign({}, asyncState), { status: AsyncStatus.ERROR, error: error })) });
};
export var asyncInitial = function (state, _a) {
    var key = _a.key, idx = _a.idx;
    var asyncStore = state.async;
    var path = idx !== undefined ? [key, idx] : [key];
    return __assign(__assign({}, state), { async: set(asyncStore, path, {
            status: AsyncStatus.INITIAL,
        }) });
};
